// src/app/modules/BulkUpload/constants/steps.js

export const STEPS = [
  'Upload File',
  'Review Validation',
  'Confirm Details',
  'Processing',
  'Results'
];

export const STEP_INDICES = {
  UPLOAD: 0,
  VALIDATION: 1,
  REVIEW: 2,
  PROCESSING: 3,
  RESULTS: 4,
};